import { useState, useEffect } from 'react';

const TRADE_ACTIVITY_TAB_LOCAL_STORAGE_KEY = 'tradeActivityPreferredTab/v2';

// Simple event emitter for intra-tab sync
const listeners = new Set<(value: number) => void>();

function notifyListeners(newValue: number) {
  listeners.forEach((listener) => listener(newValue));
}

export function useTradeActiveTab(initialTab?: number) {
  const getInitialValue = () =>
    parseInt(window.localStorage.getItem(TRADE_ACTIVITY_TAB_LOCAL_STORAGE_KEY) || '0', 10) || initialTab || 0;

  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(getInitialValue);

  // Listen for storage events (cross-tab)
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === TRADE_ACTIVITY_TAB_LOCAL_STORAGE_KEY && e.newValue) {
        setSelectedTabIndex(parseInt(e.newValue, 10));
      }
    };

    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  // Listen for local changes (same tab, different components)
  useEffect(() => {
    const listener = (newValue: number) => {
      setSelectedTabIndex(newValue);
    };
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  const updateTab = (newTab: number) => {
    window.localStorage.setItem(TRADE_ACTIVITY_TAB_LOCAL_STORAGE_KEY, newTab.toString());
    notifyListeners(newTab);
    setSelectedTabIndex(newTab);
  };

  return { selectedTabIndex, setSelectedTabIndex: updateTab };
}
